import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { performanceApi } from '~/apis';
import {
  PerfCommercePerformanceProtocolsGetCountriesRequest,
  PerfCommercePerformanceProtocolsGetCountriesResponse,
  PerfCommercePerformanceProtocolsGetDomainsRequest,
  PerfCommercePerformanceProtocolsGetDomainsResponse,
} from '~/swagger/data-contracts';

export const QueryKeyPerformance = 'performance';
const QueryKey = 'common';

export const usePerformanceCountryFilterList = () => {
  return useQuery([QueryKeyPerformance, QueryKey, 'country-filter'], async () => {
    const { data } = await performanceApi.countryListList();
    return data;
  });
};

export const usePerformanceCountryFilterQuery = <TData = PerfCommercePerformanceProtocolsGetCountriesResponse>(
  request: PerfCommercePerformanceProtocolsGetCountriesRequest,
  options?: UseQueryOptions<PerfCommercePerformanceProtocolsGetCountriesResponse, unknown, TData>
) => {
  return useQuery({
    queryKey: [QueryKeyPerformance, QueryKey, 'country-filter', request],
    queryFn: async () => {
      const { data } = await performanceApi.countriesCreate(request);
      return data;
    },
    ...options,
  });
};

export const usePerformanceDomainFilterQuery = <TData = PerfCommercePerformanceProtocolsGetDomainsResponse>(
  request: PerfCommercePerformanceProtocolsGetDomainsRequest,
  options?: UseQueryOptions<PerfCommercePerformanceProtocolsGetDomainsResponse, unknown, TData>
) => {
  return useQuery({
    queryKey: [QueryKeyPerformance, QueryKey, 'domain-filter', request],
    queryFn: async () => {
      const { data } = await performanceApi.domainsCreate(request);
      return data;
    },
    ...options,
  });
};
